import React from 'react';
import LogoutButton from 'src/components/shared/LogoutButton';
import WhiteLogo from 'src/components/shared/WhiteLogo';
import BreadcrumbsList from 'src/components/general/BreadcrumbsList';
import useStyles from './styles';
export default function SplitPageContainer(_ref) {
  let imageScr = _ref.imageScr,
    leftBlock = _ref.leftBlock,
    children = _ref.children,
    breadcrumbs = _ref.breadcrumbs,
    showLogOutButton = _ref.showLogOutButton,
    largeTopMargin = _ref.largeTopMargin,
    isAppfolio = _ref.isAppfolio;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.splitContainer
  }, !isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.tabletHeader
  }, /*#__PURE__*/React.createElement(WhiteLogo, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.leftSplit
  }, /*#__PURE__*/React.createElement(WhiteLogo, null), /*#__PURE__*/React.createElement("img", {
    className: classes.leftImg,
    src: imageScr,
    width: "269",
    height: "200"
  }), /*#__PURE__*/React.createElement("div", null, leftBlock))), isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: classes.leftAppfolioSplit
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSplit
  }, showLogOutButton && /*#__PURE__*/React.createElement(LogoutButton, null), breadcrumbs && /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumbsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumbsContent
  }, /*#__PURE__*/React.createElement(BreadcrumbsList, {
    breadcrumbsArray: breadcrumbs
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.rightBlockContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.rightBlockContent, " ").concat(largeTopMargin ? classes.largeTop : '')
  }, children))));
}